/** Typeahead lookups behind the entity, memory and repository pickers. */

import { request } from "./http";

export type LookupKind = "entity" | "memory" | "repository";

export interface LookupItem {
  id: string;
  label: string;
  detail: string | null;
}

export interface LookupResponse {
  kind: LookupKind;
  items: LookupItem[];
  /** Set when the lookup could not run, so the picker explains itself rather than looking empty. */
  detail: string | null;
}

export function fetchLookup(
  kind: LookupKind,
  query: string,
  signal?: AbortSignal,
): Promise<LookupResponse> {
  const params = new URLSearchParams();
  if (query) {
    params.set("q", query);
  }
  const suffix = params.size > 0 ? `?${params.toString()}` : "";
  return request<LookupResponse>(`/api/lookup/${kind}${suffix}`, {
    ...(signal ? { signal } : {}),
  });
}
